<!--
 * @description: 公司联系人
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="contactsList"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
    >
      <template v-slot:tabelTitleLeft>
        <div>公司联系人</div>
      </template>
      <template v-slot:tabelTitleRight>
        <add-button @buttonClick="addPower">新增</add-button>
      </template>
      <template v-slot:condition>
        <text-field
          v-model:value="conditionData.companyId"
          labelText="公司:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.LinkMan"
          labelText="姓名:"
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:oprator="$opData">
        <div class="opration">
          <div class="style-aaa" @click="delSingleUser($opData.data)">删除</div>
          <!-- <del-border
									:useConfirm="true" comfirmMessage="确定删除吗？" 
									comfirmOkText="确定" comfirmCancelText="取消" 
									@buttonClick="delSingleUser($opData.data)"></del-border> -->
        </div>
      </template>
    </tabel-panel>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import delBorder from "@/components/delBorder.vue";
import { contactsEdit, contactsDel } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import { ElMessageBox } from "element-plus";

export default {
  name: "contactsInfo",
  components: {
    delBorder,
    textField,
    addButton,
    delButton,
    tabelPanel,
    popDialog,
    updateButton,
  },
  data() {
    const selectValueFn1 = (v, item) => {
      if (item) {
        return item.Company_Id;
      }
    };
    const selectRemoteSearchData1 = async () => {
      let source = await tableApi.CompanyInfoesDatas();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };
    return {
      rowTemplate: [
        {
          headerLabel: "姓名",
          width: 80,
          sortable: true,
          dataIndex: "LinkMan",
        },
        {
          headerLabel: "公司",
          width: 180,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "公司",
          width: 120,
          dataIndex: "Company_Id",

          editable: true,
          requird: true,
          editType: "select",
          selectRemoteSearchData: selectRemoteSearchData1,
          selectValueFn: selectValueFn1,
          rules: [
            {
              required: true,
              message: "请选择公司",
            },
          ],
          showInList: false,
        },
        {
          headerLabel: "联系人",
          width: 80,
          showInList: false,
          editable: true,
          dataIndex: "LinkMan",
        },
        {
          headerLabel: "电话",
          width: 90,
          editable: true,
          sortable: true,
          dataIndex: "TelNo",
        },
        {
          headerLabel: "手机",
          sortable: true,
          editable: true,
          dataIndex: "Phone",
        },
        {
          headerLabel: "Email",
          width: 100,
          editable: true,
          dataIndex: "Email",
        },
        {
          headerLabel: "传真",
          width: 80,
          editable: true,
          dataIndex: "FaxNo",
        },
        {
          headerLabel: "邮编",
          sortable: true,
          width: 80,
          editable: true,
          dataIndex: "PostNo",
        },
        {
          headerLabel: "地址",
          sortable: true,
          editable: true,
          editType: "textarea",
          dataIndex: "Address",
          rows: 2,
        },
        {
          headerLabel: "职位",
          width: 80,
          editable: true,
          sortable: true,
          dataIndex: "Duties",
        },
        // {
        //   headerLabel: "公司",
        //   width: 120,
        //   dataIndex: "Company_Id",
        //   editable: true,
        //   requird: true,
        //   editType: "select",
        //   selectRemoteSearchData: selectRemoteSearchData1,
        //   selectValueFn: selectValueFn1,
        //   rules: [
        //     {
        //       required: true,
        //       message: "请选择公司",
        //     },
        //   ],
        //   showInList: false,
        // },
        {
          headerLabel: "是否默认联系人",
          width: 130,
          editable: true,
          sortable: true,
          dataIndex: "IsDefault",
          editType: "checkbox",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else {
              return "否";
            }
          },
          fieldData: [
            {
              value: true,
            },
          ],
        },
        // {
        //   headerLabel: "是否默认联系人",
        //   dataIndex: "IsDefault",
        //   width: 130,
        //   sortable: true,
        //   dataRender: (v) => {
        //     if (v == true) {
        //       return "是";
        //     } else if (v == false) {
        //       return "否";
        //     } else {
        //       return v;
        //     }
        //   },
        // },
        // {
        //   headerLabel: "是否默认联系人",
        //   width: 130,
        //   editable: true,
        //   showInList: false,
        //   dataIndex: "IsDefault",
        //   editType: "checkbox",
        //   fieldData: [
        //     {
        //       label: "是",
        //       value: true,
        //     },
        //   ],
        // },
        {
          headerLabel: "操作",
          slot: "oprator",
          width: 80,
        },
      ],
      conditionData: {
        companyId: null,
        LinkMan: "",
      },
    };
  },
  methods: {
    /**
     * @description: 获取下拉框数据
     * @param {*}
     * @return {*}
     */
    async selectOuguName() {
      let source = await tableApi.CompanyInfoesDatasGSLXR();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    },
    // 重新加载表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    //单列表删除
    delSingleUser({ row, columnIndex, $index }) {
      let Id = row.Id;
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          contactsDel({ Id }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      debugger;
      console.log(slotData);
      if (slotData.IsDefault == undefined) {
        slotData.IsDefault = false;
      }
      const { id } = slotData;

      if (slotData.id === null) {
        slotData.id = 0;
        // if (typeof slotData.IsDefault != "boolean") {
        //   slotData.IsDefault?.length == "0"
        //     ? (slotData.IsDefault = false)
        //     : (slotData.IsDefault = true);
        // }
        let dataStr = JSON.stringify(slotData);
        contactsEdit({ data: dataStr }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      } else {
        if (typeof slotData.IsDefault != "boolean") {
          slotData.IsDefault?.length == "0"
            ? (slotData.IsDefault = false)
            : (slotData.IsDefault = true);
        }
        let dataStr = JSON.stringify(slotData);
        contactsEdit({ data: dataStr }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      }
    },
    addPower() {
      this.$refs.tabel.showDialog();
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }
  .menuPowerBtn {
    // color:rgb(255, 255, 255)!important;
    // background:rgb(100,134,232)!important;
  }
  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }
    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }
  .oprationTree {
    height: 300px;
    overflow: auto;
  }
}

::v-deep .el-table__body-wrapper {
  overflow: auto !important;
}
.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
